module.exports = __webpack_public_path__ + "img/logo.71b33551.gif";